<template>
    <svg width="1.2rem" height="1.2rem" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 2.04492H16.2927V5.83759" stroke="#F9F9F9" stroke-width="1.22597" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M6.5 16.0449L2.70734 16.0449L2.70734 12.2523" stroke="#F9F9F9" stroke-width="1.22597"
            stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.5 6.04492L2.5 2.25226L6.29266 2.25226" stroke="#F9F9F9" stroke-width="1.22597"
            stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.5 12.0449L16.5 15.8376L12.7073 15.8376" stroke="#F9F9F9" stroke-width="1.22597"
            stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>